const easeInOutCubic = (t) =>
  t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

export const cancelSmoothScroll = (target) => {
  var node = target && target.current ? target.current : target;

  if (node && node.__mnbCancelSmoothScroll) {
    node.__mnbCancelSmoothScroll();
    node.__mnbCancelSmoothScroll = null;
  }
};

const smoothScroll = (ref, target, duration, isMouseFocus) => {
  try {
    if (isMouseFocus) return;
    if (!ref || !ref.current) return;

    // Input mode for scroll behavior
    const node = ref.current;
    cancelSmoothScroll(node);

    const start = node.scrollTop;
    const change = target - start;
    var frameId = null;
    var cancelled = false;
    const now = function () {
      if (typeof performance !== "undefined" && performance.now) {
        return performance.now();
      }
      return Date.now();
    };
    const requestFrame = function (callback) {
      if (typeof requestAnimationFrame === "function") {
        return requestAnimationFrame(callback);
      }
      return setTimeout(function () {
        callback(now());
      }, 16);
    };
    const cancelFrame = function (id) {
      if (id == null) return;
      if (typeof cancelAnimationFrame === "function") {
        cancelAnimationFrame(id);
      }
      if (typeof clearTimeout === "function") {
        clearTimeout(id);
      }
    };
    const scrollDuration = duration || 450;
    const startTime = now();

    node.__mnbCancelSmoothScroll = function () {
      cancelled = true;
      cancelFrame(frameId);
    };

    const animateScroll = (currentTime) => {
      try {
        if (cancelled || !ref.current || ref.current !== node) return;
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / scrollDuration, 1); // Clamp between 0 and 1
        const easedProgress = easeInOutCubic(progress); // Apply easing

        node.scrollTop = start + change * easedProgress;

        if (progress < 1) {
          frameId = requestFrame(animateScroll);
        } else if (node.__mnbCancelSmoothScroll) {
          node.__mnbCancelSmoothScroll = null;
        }
      } catch (err) { }
    };

    frameId = requestFrame(animateScroll);
  } catch (error) { }
};

export default smoothScroll;
